import { Directive } from '@angular/core';

import { BaseComponent } from './base.component';

export interface IFromControlValidationError {
    [code: string]: true;
}

@Directive()
export abstract class ModalBaseComponent<T, U> extends BaseComponent<T> {
    result: U;
}
